import { reviewImages } from '@/lib/media';

// ── Real, verified Oferteo reviews (rating 5.0/5) ────────────────────────────
// Single source of truth for the review data — consumed by the client
// TestimonialsSection (rendered, SSR'd into the HTML). Deliberately NOT marked
// up as Review/AggregateRating JSON-LD: Google treats reviews a business shows
// about itself as "self-serving" — ineligible for stars and a manual-action
// risk. Star ratings belong on the Google Business Profile. Do not re-add.
// `text` is the ORIGINAL language (`lang`); the Translate toggle swaps in the
// per-locale copy from the i18n `testimonials.r{id}` keys at runtime.
export interface Review {
  id: number;
  initial: string;
  lang: string;
  score: number;
  text: string;
  images: string[];
}

export const REVIEWS: Review[] = [
  {
    id: 0,
    initial: 'M.G.',
    lang: 'pl',
    score: 5,
    text:
      'Jestem architektem wnętrz, a Pan Yurii wykańczał u mnie dwie łazienki oraz schody. Z czystym sumieniem mogę potwierdzić, że sprostał dużym wymaganiom :)) łazienki były mocno skomplikowane. Robota jest wykonana precyzyjnie, nawet kanały do zrzutu prania zostały starannie wykonane wg moich wytycznych. Co ważne czytają rysunki, a jeśli coś trzeba wykonać inaczej niż w projekcie - to zawsze pytają. Taka współpraca to na 5 👍',
    images: [],
  },
  {
    id: 1,
    initial: 'E.',
    lang: 'pl',
    score: 5,
    text:
      'Świetna ekipa – fachowo, dokładnie i na czas. Jestem bardzo zadowolona z wykonania łazienek. Panowie pracują rzetelnie i z dużą dbałością o szczegóły! :)',
    images: [],
  },
  {
    id: 2,
    initial: 'A.',
    lang: 'pl',
    score: 5,
    text:
      'Firma YatFliz realizowała wykończenie naszego domu pod Warszawą, ca. 250m2 w okresie lipiec-wrzesień 2025. Ekipa stawiła się na czas, wykonała prace w terminie jak określony w umowie, pracując często długie godziny w ciągu dnia. W kwestii techniki wykonania i jakości - bez zarzutu. Gładzie i malowanie uratowały nasze nierówne tynki (ściany oświetlane m.in. Ledem świecącym prosto na ścianę). Płytki w łazienkach i pozostałych przestrzeniach położone zgodnie z projektem. Ekipa potrafi kłaść płytki wielkoformatowe (275x120) i fugi epoksydowe. Miła współpraca, nie ma rzeczy, których „się nie da zrobić”. Ewentualne małe błędy były naprawiane bez zbędnego „ale”. Czekamy jedynie na finalizację ostatnich prac po położeniu podłóg przez parkieciarza.',
    images: reviewImages.A,
  },
  {
    id: 3,
    initial: 'R.',
    lang: 'pl',
    score: 5,
    text:
      'Wszystko w porządku, solidna i dobrej jakości robota, terminowo jak ustalone. Polecam tego wykonawcę.',
    images: [],
  },
  {
    id: 4,
    initial: 'R.',
    lang: 'pl',
    score: 5,
    text:
      'Bardzo dokładna i staranna ekipa. Wszystko zgodnie z ustaleniami. Bardzo polecam.',
    images: [],
  },
  {
    id: 5,
    initial: 'A.',
    lang: 'pl',
    score: 5,
    text:
      'Yurii bardzo skutecznie i szybko zrobił wykończenie łazienki. Sprawdzałem ceny u innych fachowców i okazało się, że Yurij miał najkorzystniejszą ofertę. Polecam z czystego serca.',
    images: reviewImages.AM,
  },
  {
    id: 6,
    initial: 'O.',
    lang: 'pl',
    score: 5,
    text:
      'super fachowiec, robi świetną robotę, współpraca to przyjemność',
    images: [],
  },
];

// Aggregate figures for the on-page trust badge only (no schema markup — see above).
export const REVIEWS_COUNT = REVIEWS.length;
export const REVIEWS_BEST_RATING = 5;
export const REVIEWS_AVG_RATING =
  Math.round((REVIEWS.reduce((sum, r) => sum + r.score, 0) / REVIEWS.length) * 10) / 10;
